import React, { useEffect, useState } from 'react'
import { assets } from '../assets/assets'


const ChatBot = () => {

    const [open, setOpen] = useState(false);
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [dynamicHeight, setDynamicHeight] = useState('80vh');
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);


    const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";

    useEffect(()=>{
            if(open && messages.length === 0) {
                const welcomeMessage = {role: 'bot', content: 'Hi, what can I help you with today!'};
                setMessages([welcomeMessage]);
            }
    },[open, messages.length]);
    const sendMessage = async (userMessage) => {
   
    
    const res = await fetch(`${API_BASE}/api/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: userMessage }),
    });

    const data = await res.json();
    return data.reply;
    };


    const handleSend = async () => {
        if (!input.trim()) return;

        const userMsg = { role: 'user', content: input };
        setMessages((prev) => [...prev, userMsg]);
        setInput('');

        try {
            const botReply = await sendMessage(input);
            const botMsg = { role: 'bot', content: botReply };
            setMessages((prev) => [...prev, botMsg]);
        } catch (err) {
            console.error("Error:", err);
        }
    };

    useEffect(() => {
        if (open && isMobile) {
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.overflow = 'hidden';
            document.body.dataset.scrollY = scrollY;
        } else if (!open && isMobile && document.body.style.position === 'fixed') {
            const scrollY = document.body.dataset.scrollY;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.overflow = '';
            window.scrollTo(0, parseInt(scrollY || '0'));
        }

        return () => {
            if (isMobile && document.body.style.position === 'fixed') {
                const scrollY = document.body.dataset.scrollY;
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.left = '';
                document.body.style.right = '';
                document.body.style.overflow = '';
                window.scrollTo(0, parseInt(scrollY || '0'));
            }
        };
    }, [open, isMobile]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleViewportResize = () => {
            const vh = window.visualViewport?.height || window.innerHeight;
            const newVH = vh * 0.01;
            document.documentElement.style.setProperty('--vh', `${newVH}px`);
        };

        handleViewportResize();

        // For iOS Safari: use visualViewport
        window.visualViewport?.addEventListener('resize', handleViewportResize);
        window.addEventListener('orientationchange', handleViewportResize);

        return () => {
            window.visualViewport?.removeEventListener('resize', handleViewportResize);
            window.removeEventListener('orientationchange', handleViewportResize);
        };
    }, []);

    useEffect(() => {
        const updateVH = () => {
            // Only apply on small screens (<768px)
            if (window.innerWidth < 768) {
                const vh = window.visualViewport?.height || window.innerHeight;
                setDynamicHeight(`${vh * 0.8}px`);
            } else {
                setDynamicHeight('450px'); // fallback for md and up
            }
        };

        updateVH();

        window.visualViewport?.addEventListener('resize', updateVH);
        window.addEventListener('orientationchange', updateVH);
        window.addEventListener('resize', updateVH);

        return () => {
            window.visualViewport?.removeEventListener('resize', updateVH);
            window.removeEventListener('orientationchange', updateVH);
            window.removeEventListener('resize', updateVH);
        };
    }, []);
    
    return (
        
        <div className='fixed bottom-4 right-2 z-50'>
        {!open &&(
            <div onClick={()=> setOpen(!open)} className="group cursor-pointer relative w-[100px] h-[100px]">
                <svg className="absolute inset-0 group-hover:animate-wiggle" width="100" height="100">
                    <circle cx="50" cy="50" r="20" fill="gray" />
                </svg>
                <img 
                    src={assets.chatIcon} 
                    className='group-hover:animate-wiggle absolute inset-0 w-10 height-auto top-8 left-7 object-contain' 
                    alt= 'chat icon' 
                />
            </div>
        )}

        {open && (
            <div className={`border-4 border-gray-400 
                            bg-[#191919] shadow-[0_-5px_20px_5px_rgba(255,0,255,0.15)] rounded-lg p-4 w-[90vw]
                            fixed z-50 
                            ${isMobile 
                                ? 'left-1/2 top-[50%] transform -translate-x-1/2 -translate-y-1/2' 
                                : 'md:w-80 md:h-[450px] md:bottom-16 md:right-4 md:left-auto md:top-auto md:translate-x-0'}`} 
                            style={isMobile ? { height: dynamicHeight } : {}}>

                <button 
                    onClick={() => setOpen(false)} 
                    className="absolute -top-4 -right-4 text-white bg-gray-700 hover:bg-gray-700 rounded-full p-1 w-10 h-10 flex items-center justify-center hover:animate-wiggle">
                    <img className='h-5 y-auto'src={assets.crossIcon} alt='x'/>
                </button>


                <div className="text-white text-lg font-bold mb-3 bg-gray-800 rounded pb-1 text-center">
                    Chat
                </div>


                <div className="text-gray-600 h-[calc(100%-6rem)] md:h-[320px] overflow-y-auto py-2 border-2 border-gray-500 rounded hide-scrollbar bg-black">
                    {messages.map((msg, i) => (
                    <div key={i} className={`mb-2 ${msg.role === 'user' ? 'text-right text-gray-700 pl-7 pr-2' : 'text-left text-gray-800 pl-2 pr-7'}`}>
                        <div className={`inline-block p-2 rounded ${msg.role === 'user' ? 'bg-blue-200' : 'text-white bg-gray-700'}`}>
                            {msg.content}
                        </div>
                    </div>
                ))}
                </div>
                
                    <input
                        value = {input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSend()}
                        className="border-2 border-gray-500 text-white placeholder:text-white font-bold w-full mt-2 p-2 rounded 
                                    bg-gradient-to-r from-purple-900 via-blue-800 to-pink-900
                                    bg-[length:200%_200%] animate-gradientX "
                        placeholder="Type a message..."
                    />
                
            </div>
            
        )}

    </div>
  )
}

export default ChatBot
